import { useState, lazy } from 'react'
import { GlobalProvider } from './context/GlobalProvider';

import "./App.scss";

interface Props {
    rtl: boolean;
}

const TrackOrderManager = lazy(() => import('./TrackOrderManager'));

function App() {
    return (
        <GlobalProvider>
            <TrackOrderManager />
        </GlobalProvider>
    );
}

export default App;